import React, { useEffect, useState } from 'react'
import { postData } from '../../services/api'
import dayjs from 'dayjs'
import PieChart from "highcharts-react-official";
import Highcharts from 'highcharts/highcharts'
import { Box, Checkbox, FormControl, ListItemText, MenuItem, Select } from '@mui/material';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
export default function SellingTrendByCatalog({ budgetYears, types, catalogs }) {
    const [type, setType] = useState('all')
    const [catalog, setCatalog] = useState([])
    const [catalogNo, setCatalogNo] = useState([])
    const [season, setSeason] = useState('all')
    const [branchsNo, setBranchsNo] = useState('all')
    const [years, setYear] = useState(dayjs(new Date()).add(3, 'month').format('BBBB'))
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const getData = async () => {
        const body = {
            BranchNo:
                []
            ,
            Season:
                []
            ,
            TypeNo:
                type === 'all' ? [] : [type],
            CatalogNo: catalogNo,
            BudgetYear: [years],
            Month: [],
            Day: []
        }
        setIsLoading(true)
        const res = await postData('dashboard/back/selling-trend-by-catalog', body)
        if (res.status === true) {
            setData(res.result)
            setIsLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [type, years, catalogNo])
    const handleChange = (event) => {

        const {
            target: { value },
        } = event;

        setCatalog(
            // On autofill we get a stringified value.
            value?.length > catalogs?.length ? [] : value.filter((x) => x === 'all').length > 0 ? catalogs?.map((y) => y?.CatalogName) : value,
        );
        setCatalogNo(value?.length > catalogs?.length ? [] : value.filter((x) => x === 'all').length > 0 ? catalogs?.map((y) => y?.CatalogNo) : value.map((x) => catalogs?.find((y) => y?.CatalogName === x)?.CatalogNo));

    };
    return (
        <>
            <div class="row">
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: "space-between" }}>
                    <h2 className='dash-title'>
                        เเนวโน้มการจำหน่ายรายพันธุ์
                    </h2>
                    <Box sx={{ display: 'flex', flexDirection: { md: "row", xs: 'column' }, justifyContent: "flex-end", '& .backgroundField': { background: "#d8ceff" } }}>
                        <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            <FormControl variant="standard" fullWidth >
                                <Select
                                    onChange={e => setYear(e.target.value)}
                                    disableUnderline
                                    value={years || ''}
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    {budgetYears?.map((x, i) => (
                                        <MenuItem value={x?.BudgetYear}>{x?.BudgetYear}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={type}
                                    onChange={e => setType(e.target.value)}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>ชนิดข้าวทั้งหมด</MenuItem>
                                    {types?.map((x, i) => (
                                        <MenuItem value={x?.TypeName}>{x?.TypeName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box className='backgroundField' sx={{ marginRight: '20px', marginBottom: { md: '0', xs: '10px' } }}>
                            {/* <FormControl variant="standard" fullWidth >
                                <Select value={catalog}
                                    onChange={e => setCatalog(e.target.value)}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>พันธุ์ทั้งหมด</MenuItem>
                                    {catalogs?.map((x, i) => (
                                        <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl> */}
                            <FormControl variant="standard" sx={{ width: 120 }} >
                                <Select value={catalog}
                                    // onChange={e => setCatalog(e.target.value)}
                                    multiple
                                    displayEmpty
                                    // value={personName}
                                    onChange={handleChange}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                            return <>พันธุ์</>;
                                        }
                                        return selected?.join(', ')
                                    }}
                                    MenuProps={MenuProps}
                                    disableUnderline
                                // MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    {/* <MenuItem value='all'>พันธุ์ทั้งหมด</MenuItem>
                                {catalogs?.map((x, i) => (
                                    <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                ))} */}
                                    <MenuItem value="all">
                                        <Checkbox checked={catalog?.length === catalogs?.length} />
                                        <ListItemText primary={'พันธุ์ทั้งหมด'} />
                                    </MenuItem>
                                    {catalogs?.map((name, i) => (
                                        <MenuItem key={i} value={name?.CatalogName}>
                                            <Checkbox checked={catalog?.indexOf(name?.CatalogName) > -1} />
                                            <ListItemText primary={name?.CatalogName} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>


                    </Box>
                </Box>
            </div>
            <div class="row">
                <div class="col-12">
                    {!isLoading && <Dashboard dataDashboard={data} years={years} />}
                </div>
            </div>
        </>
    )
}
function Dashboard({ dataDashboard, years }) {

    const options = {
        chart: {
            type: 'column',
            // scrollablePlotArea: {
            //     minWidth: dataDashboard?.map((x) => x?.CatalogName)?.length * 150,
            //     scrollPositionX: 1,
                
            // },
            zoomType:'x',
            
        },
        title: {
            text: null
        },
        subtitle: {
            text: 'หน่วย : ตัน',
            align: 'left'
        },
        xAxis: {
            categories: dataDashboard?.map((x) => x?.CatalogName),
            crosshair: true,
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        yAxis: {
            min: 0,
            title: {
                text: null
            },
            labels: {
                formatter: function () {
                    return this.value.toLocaleString();
                }
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            series: {
                borderRadiusTopLeft: 8,
                borderRadiusTopRight: 8
            },
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            }
        },
        series: [{
            name: +years - 2,
            data: dataDashboard?.map((x) => +(x?.OldQty / 1000)?.toFixed(2)),
            color: '#5ce1e6',
            type: 'column'

        }, {
            name: +years - 1,
            data: dataDashboard?.map((x) => +(x?.LastQty / 1000)?.toFixed(2)),
            color: '#ffde59',
            type: 'column'

        }]
    }
    return (
        <>
            <>{dataDashboard && <PieChart options={options} highcharts={Highcharts} />}</>
        </>
    )
}
